import service from './../utils/server'

const modName = '/common/web/select/';
/**
 * 用户类型
 * @param data
 */
export const userType = data => {
    return service({
        url: modName + 'userType',
        method: 'post',
        data
    })
};

export const getUserCategory = data => {
  return service({
    url: modName + 'getUserCategory',
    method: 'post',
    data
  });
};

/**
 * 仓库
 */
export const wareHouse = data => {
  return service({
    url: modName + 'wareHouse',
    method: 'post',
    data
  })
};

/**
 * 品牌
 */
export const selectBrand = data => {
  return service({
    url: modName + 'selectBrand',
    method: 'post',
    data
  })
};

/**
 * 根据用户编码查询所管理的品牌列表
 * @param data
 */
export const selectBrandByUserNo = data => {
  return service({
    url: modName + 'selectBrandByUserNo',
    method: 'post',
    data
  })
};

/**
 * 查询车型
 * @param data
 * @returns {AxiosPromise}
 */
export const selectTruckType = data => {
  return service({
    url: modName + 'selectTruckType',
    method: 'post',
    data
  });
};

/**
 * 售卖类型
 */
export const selectSellType = data => {
  return service({
    url: modName + 'selectSellType',
    method: 'post',
    data
  })
};

/**
 * 差异原因
 */
export const selectTicketReason = data => {
  return service({
    url: modName + 'selectTicketReason',
    method: 'post',
    data
  })
};

/**
 * 运输商
 */
export const carrier = data => {
  return service({
    url: modName + 'carrier',
    method: 'post',
    data
  })
};

/**
 * 运输方式
 */
export const transWay = data => {
  return service({
    url: modName + 'transWay',
    method: 'post',
    data
  })
};

/**
 * 订单状态
 */
export const soStatus = data => {
  return service({
    url: modName + 'soStatus',
    method: 'post',
    data
  })
};

/**
 * 销售类型
 */
export const salesType = data => {
  return service({
    url: modName + 'salesType',
    method: 'post',
    data
  })
};

/**
 * 发货单状态
 */
export const doStatus = data => {
  return service({
    url: modName + 'doStatus',
    method: 'post',
    data
  })
};

/**
 * 配送线路
 */
export const routeInfo = data => {
  return service({
    url: modName + 'routeInfo',
    method: 'post',
    data
  })
};


/**
 * 周转箱状态
 */
export const recycleBoxStatus = data => {
  return service({
    url: modName + 'recycleBoxStatus',
    method: 'post',
    data
  })
};

/**
 * 柜台要求送货日修改原因
 */
export const counterReqArriveDateReason = data => {
  return service({
    url: modName + 'counterReqArriveDateReason',
    method: 'post',
    data
  })
};


/**
 * 货运公司
 */
export const carrierInfo = data => {
  return service({
    url: modName + 'carrier',
    method: 'post',
    data
  })
};

/**
 * 箱规
 */
export const selectBoxType = data => {
  return service({
    url: modName + 'selectBoxType',
    method: 'post',
    data
  })
};



/**
 * 处理方式
 */
export const solveType = data => {
  return service({
    url: modName + 'solveType',
    method: 'post',
    data
  })
};


/**
 * 赔偿方式
 */
export const solveCompensation = data => {
  return service({
    url: modName + 'solveCompensation',
    method: 'post',
    data
  })
};


/**
 * 赔偿金额
 */
export const solveCompensationAmount = data => {
  return service({
    url: modName + 'solveCompensationAmount',
    method: 'post',
    data
  })
};

/**
 * 差异状态
 */
export const ticketStatus = data => {
  return service({
    url: modName + 'ticketStatus',
    method: 'post',
    data
  })
};

/**
 * 差异审批状态
 */
export const ticketApproveStatus = data => {
  return service({
    url: modName + 'ticketApproveStatus',
    method: 'post',
    data
  })
};

/**
 * 差异状态
 */
export const scTicketStatus = data => {
  return service({
    url: modName + 'scTicketStatus',
    method: 'post',
    data
  })
};

/**
 * 扫码方式下拉
 */
export const selectScanInfo = data => {
  return service({
    url: modName + 'scanStatus',
    method: 'post',
    data
  })
};

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};

/**
 * 区域
 */
export const selectRegion = data => {
  return service({
    url: modName + 'selectRegionList',
    method: 'post',
    data
  })
};

/*
* 物流商
*/
export const selectCarrier = data => {
  return service({
    url: modName + 'carrierInfo',
    method: 'post',
    data
  })
};

/*
* 延迟原因
*/
export const selectDelayResonCode = data => {
  return service({
    url: modName + 'delayResonCode',
    method: 'post',
    data
  })
};

/*
* 品牌
*/
export const mdBrandList = data => {
  return service({
    url: modName + 'mdBrandList',
    method: 'post',
    data
  })
};

/*
* 接口方代码
*/
export const listInterfaceCode = data => {
  return service({
    url: modName + 'listInterfaceCode',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/api/selects.js